import React, { Children } from 'react';
import { motion } from 'framer-motion';
import { XCircle } from 'lucide-react';
import { SectionWrapper } from '../ui/SectionWrapper';
export function ProblemSection() {
  const fadeUp = {
    hidden: {
      opacity: 0,
      y: 30
    },
    visible: {
      opacity: 1,
      y: 0,
      transition: {
        duration: 0.6,
        ease: 'easeOut'
      }
    }
  };
  const staggerContainer = {
    hidden: {
      opacity: 0
    },
    visible: {
      opacity: 1,
      transition: {
        staggerChildren: 0.15
      }
    }
  };
  const failedAttempts = [{
    title: 'Tratar de ser "más carismático"',
    desc: 'Es subjetivo y no siempre funciona con perfiles difíciles.'
  }, {
    title: 'Explicar tus motivos con lógica',
    desc: 'La lógica no mueve voluntades, los marcos mentales sí.'
  }, {
    title: 'Ceder para caer bien',
    desc: 'Solo te posiciona como alguien fácil de influenciar, no como un líder.'
  }, {
    title: 'Los "trucos" de ventas de los 90',
    desc: 'Hoy todo el mundo los detecta y generan rechazo inmediato.'
  }];
  return <SectionWrapper className="bg-bg relative" data-id="element-125">
      <motion.div initial="hidden" whileInView="visible" viewport={{
      once: true,
      margin: '-100px'
    }} variants={staggerContainer} className="max-w-3xl mx-auto" data-id="element-126">
        <motion.h2 variants={fadeUp} className="font-heading text-2xl md:text-4xl font-semibold text-text-primary leading-tight mb-12 border-l-4 border-accent pl-6" data-id="element-127">
          Saber lo que otros piensan es útil. Pero lograr que piensen lo que vos
          necesitás, es <span className="text-accent" data-id="element-128">poder real</span>.
        </motion.h2>

        <motion.p variants={fadeUp} className="font-body text-lg text-text-secondary mb-12 leading-relaxed" data-id="element-129">
          En toda interacción humana hay una jerarquía invisible. No se basa en
          quién grita más fuerte ni en quién tiene el mejor título, sino en
          quién domina el Marco Mental. La mayoría de la gente reacciona a la
          realidad que otros proponen; unos pocos elegidos son los que
          construyen la realidad a la que los demás se adaptan.
        </motion.p>

        <div className="space-y-6 mb-12" data-id="element-130">
          <motion.div variants={fadeUp} className="bg-surface border border-border p-6 rounded-lg" data-id="element-131">
            <p className="font-body text-text-primary text-lg italic" data-id="element-132">
              "¿Alguna vez sentiste que tenías la razón, pero terminaron
              haciendo lo que otra persona propuso?"
            </p>
          </motion.div>
          <motion.div variants={fadeUp} className="bg-surface border border-border p-6 rounded-lg" data-id="element-133">
            <p className="font-body text-text-primary text-lg italic" data-id="element-134">
              "¿Alguna vez tuviste una idea brillante que murió en el silencio
              porque no supiste cómo 'venderla' sin que pareciera que estabas
              presionando?"
            </p>
          </motion.div>
        </div>

        <motion.p variants={fadeUp} className="font-body text-lg text-text-secondary mb-16 leading-relaxed" data-id="element-135">
          El problema es que intentar convencer a alguien es activar sus
          defensas. Cuando empujás una idea, la respuesta biológica del otro es
          empujar de vuelta. Por eso la persuasión tradicional falla:{' '}
          <strong className="text-text-primary font-semibold" data-id="element-136">
            porque se nota.
          </strong>
        </motion.p>

        <motion.div variants={fadeUp} className="mt-16" data-id="element-137">
          <h3 className="font-heading text-lg md:text-xl font-bold text-text-primary uppercase tracking-wider mb-8 text-center md:text-left md:flex md:items-center md:gap-3" data-id="element-138">
            <span className="hidden md:block w-8 h-[1px] bg-border" data-id="element-139"></span>
            Por qué lo que intentaste no funcionó
            <span className="hidden md:block w-8 h-[1px] bg-border" data-id="element-140"></span>
          </h3>

          <div className="grid grid-cols-1 md:grid-cols-2 gap-6" data-id="element-141">
            {failedAttempts.map((item, idx) => <motion.div key={idx} variants={fadeUp} className="flex items-start gap-4 p-5 rounded-lg border border-border/50 bg-surface/50" data-id="element-142">
                <XCircle className="w-6 h-6 text-red-500/80 shrink-0 mt-1" data-id="element-143" />
                <div data-id="element-144">
                  <h4 className="font-heading font-bold text-text-primary mb-1" data-id="element-145">
                    {item.title}
                  </h4>
                  <p className="font-body text-sm text-text-secondary leading-relaxed" data-id="element-146">
                    {item.desc}
                  </p>
                </div>
              </motion.div>)}
          </div>
        </motion.div>
      </motion.div>
    </SectionWrapper>;
}